module.exports = __webpack_public_path__ + "media/ab-homepage/customize-ef0585ea.png";